import { Edit } from "@mui/icons-material"
import { Typography, styled } from "@mui/material"
import type React from "react"
import { useState } from "react"
import { useParams } from "react-router"
import Button from "../../../Shared/Button"
import { useGetAsset } from "../../../WatchedLocations/hooks/useAssetService"
import { SectionContainer } from "../../LocationRisk/Shared"
import { DisplaySiteDetails } from "./DisplaySiteDetails"
import { EditSiteDetails } from "./EditSiteDetails"

const SectionHeaderContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
})

const SectionContainerStyled = styled(SectionContainer)({
  maxWidth: 600,
})

export const SiteDetailSiteSection: React.FC = () => {
  const { asset_id } = useParams<{ asset_id: string }>()
  const { data } = useGetAsset(asset_id)
  const [isEditing, setIsEditing] = useState(false)
  const asset = data?.asset

  if (!asset) return null

  return (
    <SectionContainerStyled>
      <SectionHeaderContainer>
        <Typography variant="h3Bold">Site</Typography>
        <Button
          variant="text"
          startIcon={
            <Edit
              sx={{
                height: 18,
                width: 18,
                marginBottom: "2px",
                opacity: isEditing ? 0 : 1,
              }}
            />
          }
          onClick={() => setIsEditing(prev => !prev)}
          disabled={isEditing}
        >
          {isEditing ? "" : "Edit"}
        </Button>
      </SectionHeaderContainer>
      {isEditing ? (
        <EditSiteDetails asset={asset} setIsEditing={setIsEditing} />
      ) : (
        <DisplaySiteDetails asset={asset} />
      )}
    </SectionContainerStyled>
  )
}
